import { render, staticRenderFns } from "./RequestDocDialog.vue?vue&type=template&id=2ab97b97&scoped=true&"
import script from "./RequestDocDialog.vue?vue&type=script&lang=js&"
export * from "./RequestDocDialog.vue?vue&type=script&lang=js&"
import style0 from "./RequestDocDialog.vue?vue&type=style&index=0&id=2ab97b97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab97b97",
  null
  
)

export default component.exports